import { createContext } from 'react';

import { emptyFn } from '@app/constants';
import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';
import type { NTaskListProvider } from '@app/providers/TaskListProvider/types';

import type { FormInstance } from 'antd/lib';

export const TaskListProviderContext = createContext<NTaskListProvider.State>({
  activeTab: 'registry',
  onChangeTab: emptyFn,
  headerTitle: '',
  toPrevDate: emptyFn,
  toNextDate: emptyFn,
  currentDate: {
    year: 0,
    month: 0,
    day: 0,
    week: 0,
  },
  isCalendarsTabsLoading: false,
  dailyTasks: {
    dailyTaskList: [],
    fullDayTasks: [],
  },
  monthlyTasks: {},
  weeklyTasks: [],
  monthWeeks: [],
  onMouseEnter: emptyFn,
  hoveredMonthTaskId: null,
  onChangeHoveredMonthTaskId: emptyFn,
  movedMonthTaskInfo: null,
  onChangeMovedMonthTaskInfo: emptyFn,
  openCreateTaskModal: emptyFn,
  closeTaskDetailsModal: emptyFn,
  createTaskForRange: emptyFn,
  openEditTaskModal: emptyFn,
  tableHeaderForm: {
    getFieldValue: emptyFn,
    getFieldsValue: emptyFn,
    getFieldError: emptyFn,
    getFieldsError: emptyFn,
    getFieldWarning: emptyFn,
    isFieldsTouched: emptyFn,
    isFieldTouched: emptyFn,
    isFieldValidating: emptyFn,
    isFieldsValidating: emptyFn,
    resetFields: emptyFn,
    setFields: emptyFn,
    setFieldValue: emptyFn,
    setFieldsValue: emptyFn,
    validateFields: emptyFn,
    submit: emptyFn,
  } as unknown as FormInstance<NTasksList.TableHeaderFormType>,
  handleReset: emptyFn,
  selectedStatuses: [],
  setSelectedStatuses: emptyFn,
  selectedCreators: [],
  setSelectedCreators: emptyFn,
  selectedBranches: [],
  setSelectedBranches: emptyFn,
  selectedEmployee: [],
  setSelectedEmployee: emptyFn,
  searchTasks: emptyFn,
  selectorFilterData: undefined,
  selectFilterGroup: () => Promise.resolve(),
  periodTypeFilterList: [],
  statusesFilterList: [],
  ownersFilterList: [],
  creatorsFilterList: [],
  isRegistryTableLoading: false,
  tableData: [],
  rowSelection: undefined,
  pagination: undefined,
  MassActionButton: <></>,
  openPreviewTaskModal: emptyFn,
  createTaskForLead: emptyFn,
  selectTaskForAction: emptyFn,
  onChangeSuccess: emptyFn,
  isChangeEmployeeModalOpen: false,
  closeChangeEmployeeModal: emptyFn,
  selectedRowKeys: [],
  skipSelectedRows: emptyFn,
  branchesFilterList: [],
  taskTypesFilterList: [],
  selectedTaskTypes: [],
  setSelectedTaskTypes: emptyFn,
});
